import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PlatformSelector = ({ selectedPlatform, onPlatformSelect, connectedAccounts }) => {

  const platforms = [
    {
      id: 'spotify',
      name: 'Spotify',
      icon: 'Music',
      color: 'text-success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/20',
      description: 'Stream millions of songs and podcasts',
      connected: connectedAccounts.spotify
    },
    {
      id: 'youtube',
      name: 'YouTube Music',
      icon: 'Play',
      color: 'text-error',
      bgColor: 'bg-error/10',
      borderColor: 'border-error/20',
      description: 'Music streaming with video content',
      connected: connectedAccounts.youtube
    }
  ];

  return (
    <div className="space-y-4">
      <div className="text-center mb-6">
        <h2 className="text-xl font-semibold text-text-primary mb-2">
          Select Source Platform
        </h2>
        <p className="text-text-secondary">
          Choose which platform you want to sync playlists from
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {platforms.map((platform) => (
          <button
            key={platform.id}
            onClick={() => platform.connected && onPlatformSelect(platform.id)}
            disabled={!platform.connected}
            className={`relative p-6 rounded-xl border-2 transition-all duration-200 text-left ${
              selectedPlatform === platform.id
                ? `${platform.borderColor} ${platform.bgColor} shadow-elevation-2`
                : platform.connected
                ? 'border-border bg-surface hover:bg-surface-secondary hover:border-border-secondary' :'border-border bg-surface opacity-50 cursor-not-allowed'
            }`}
          >
            <div className="flex items-start space-x-4">
              <div className={`flex items-center justify-center w-12 h-12 rounded-lg ${
                selectedPlatform === platform.id ? platform.bgColor : 'bg-surface-secondary'
              }`}>
                <Icon 
                  name={platform.icon} 
                  size={24} 
                  className={selectedPlatform === platform.id ? platform.color : 'text-text-muted'}
                />
              </div>
              
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-1">
                  <h3 className="text-lg font-medium text-text-primary">
                    {platform.name}
                  </h3>
                  {selectedPlatform === platform.id && (
                    <Icon name="Check" size={16} className={platform.color} />
                  )}
                </div>
                
                <p className="text-sm text-text-secondary mb-3">
                  {platform.description}
                </p>
                
                <div className="flex items-center space-x-2">
                  <div className={`w-2 h-2 rounded-full ${
                    platform.connected ? 'bg-success' : 'bg-error'
                  }`}></div>
                  <span className={`text-xs font-medium ${
                    platform.connected ? 'text-success' : 'text-error'
                  }`}>
                    {platform.connected ? 'Connected' : 'Not Connected'}
                  </span>
                </div>
              </div>
            </div>

            {!platform.connected && (
              <div className="absolute inset-0 flex items-center justify-center bg-surface/80 rounded-xl">
                <div className="text-center">
                  <Icon name="Link" size={24} className="text-text-muted mx-auto mb-2" />
                  <p className="text-sm text-text-muted">Connect account first</p>
                </div>
              </div>
            )}
          </button>
        ))}
      </div>

      {!connectedAccounts.spotify && !connectedAccounts.youtube && (
        <div className="text-center p-6 bg-warning/10 border border-warning/20 rounded-lg">
          <Icon name="AlertTriangle" size={24} className="text-warning mx-auto mb-2" />
          <p className="text-sm text-warning mb-3">
            No accounts connected. Please connect at least one account to continue.
          </p>
          <Button 
            variant="warning" 
            iconName="Link" 
            iconSize={16}
            onClick={() => window.location.href = '/authentication-account-connection'}
          >
            Connect Accounts
          </Button>
        </div>
      )}
    </div>
  );
};

export default PlatformSelector;